import { combineReducers } from 'redux';
import { createReducer } from 'typesafe-actions';

import { fetchExperimentsAsync } from './actions';
import type { ExperimentsConfig } from './types';

export const isFetching = createReducer(false as boolean)
  .handleAction([fetchExperimentsAsync.request], () => true)
  .handleAction([fetchExperimentsAsync.success, fetchExperimentsAsync.failure], () => false);

export const config = createReducer(null as ExperimentsConfig | null).handleAction(
  fetchExperimentsAsync.success,
  (_, action) => action.payload,
);

export const errors = createReducer([] as string[])
  .handleAction(fetchExperimentsAsync.failure, (_, action) => [action.payload])
  .handleAction(fetchExperimentsAsync.success, () => []);

export const userId = createReducer(null as string | null).handleAction(
  'SET_USER_ID',
  (state, action) => action.payload,
);

const experimentsReducer = combineReducers({
  isFetching,
  config,
  errors,
  userId,
});

export default experimentsReducer;
export type ExperimentsState = ReturnType<typeof experimentsReducer>;
